// extracted by mini-css-extract-plugin
export default {"formFooter":"ManagersForm_formFooter__FvCyl"};